import { apiWobaInventory } from "../api-woba-inventory";
import {
  StatisticalAnalysisParams,
  StatisticalAnalysisResponse,
} from "./types";

export const statisticalAnalysisService = {
  async getStatisticalAnalysis(
    neighborhood: string,
    params: StatisticalAnalysisParams,
  ): Promise<StatisticalAnalysisResponse> {
    try {
      const queryParams: Record<string, number> = {
        capacity: params.capacity,
        sizeM2: params.sizeM2,
      };

      if (params.monthlyPrice > 0) {
        queryParams.monthlyPrice = params.monthlyPrice;
      }

      const { data } = await apiWobaInventory.get(
        `/private-offices/statistical-analysis/${encodeURIComponent(neighborhood)}`,
        {
          params: queryParams,
        },
      );

      return data;
    } catch (error) {
      console.error("Error fetching statistical analysis:", error);
      throw error;
    }
  },
};

export * from "./types";
